export default {
  handler: 'relativeUrl',
  data: ({ competitionGroup }) => (
    `/virtuals/${competitionGroup}`
  ),
};
